import React, { useEffect, useState } from "react";
import axios from "axios";

import GDPLineChartLarge from "./GDPLineChartLarge";
import GDPLineChartSmall from "./GDPLineChartSmall";
// import dataGDP from "../dataGDP";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

export default function ColumnsGrid() {
  const [dataGDP, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://thinktank.phbs.pku.edu.cn/api/GDP")
      .then((response) => {
        console.log(response.data);
        setData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div>
      <div className="largeCharts">
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 1, md: 3 }}
            columns={{ xs: 1, sm: 1, md: 3 }}
          >
            {dataGDP.map((GDP) => (
              <GDPLineChartLarge
                key={GDP.key}
                yLabel={GDP.yLabel}
                yData={GDP.yData}
                prData={GDP.prData}
                xLabels={GDP.xLabels}
                updateDate={GDP.updateDate}
                indicator={GDP.indicator}
              />
            ))}
          </Grid>
        </Box>
      </div>
      <div className="smallCharts">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={0.5} columns={1}>
            {dataGDP.map((GDP) => (
              <GDPLineChartSmall
                key={GDP.key}
                yLabel={GDP.yLabel}
                yData={GDP.yData}
                prData={GDP.prData}
                xLabels={GDP.xLabels}
                updateDate={GDP.updateDate}
                indicator={GDP.indicator}
              />
            ))}
          </Grid>
        </Box>
      </div>
    </div>
  );
}
